import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader } from 'reactstrap';
import AuthLoader from '../../../components/page_messaging/AuthLoader';
import AuthError from '../../../components/page_messaging/AuthError';
import * as app_consts from "../../../../constants/react_app_consts";
import { employee_dashboard_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_warehouse_storages_list, loading_retrieve_warehouse_storages_list, reset_retrieve_warehouse_storages_list, success_retrieve_warehouse_storages_list } from '../../../../reducers/dashboard_reducers/warehouse/retrieve_warehouse_storages_list_Slice';
import { EDIT_LOADING_ORDER_PRODUCTS_ACCESS_DENIED_MSG, EDIT_LOADING_ORDER_PRODUCTS_ERR_MSG, EDIT_LOADING_ORDER_PRODUCTS_SUCCESS_MSG, RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG, RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG, RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG, RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_LIST_ERR_MSG, RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG } from '../../../../constants/success_error_messages_consts';
import { EDIT_LOADING_ORDER_PRODUCTS_API, RETRIEVE_ACTIVE_AVAILABLE_PRODUCTS_API, RETRIEVE_ACTIVE_PRODUCT_LIST, RETRIEVE_BRANCH_LOCATION_LIST } from '../../../../api/api_data';
import { fail_product_list, loading_product_list, reset_product_list, success_product_list } from '../../../../reducers/dashboard_reducers/products/product_list_Slice';
import { fail_branch_location_list, loading_branch_location_list, success_branch_location_list } from '../../../../reducers/dashboard_reducers/branch_locations/branch_location_list_Slice';
import { Block, BlockBetween, BlockHead, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, Row, RSelect } from '../../../../components/Component';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import { getSelectedOption } from '../../../../utils/functionalUtils';
import TextInput from '../../../components/inputs/TextInput';
import ModalConfirmCancel from './modal_confirm_cancel/ModalConfirmCancel';
import { fail_add_product_to_loading_order, loading_add_product_to_loading_order, reset_add_product_to_loading_order, success_add_product_to_loading_order } from '../../../../reducers/dashboard_reducers/loading_orders/add_product_to_loading_order_Slice';
import { useParams } from 'react-router';


const initialState = { branch_location_label: "", branch_location_id: "", warehouse_storage_type_id: "", warehouse_storage_label: "", delivery_location: "", product_label: "", product_id: "", product_type_label: "", product_type_id: "", weight_in_kilos: "", quantity_available: "", packaging_number: "", quantity_in_mt: "", packet_size: "", base_weight_in_kilos: "", loading_order_ref_no: "" };


const EditLoadingOrderProductsModal = ({ isOpen, cloasModal, successFunction, data }) => {

  const [open, setOpen] = useState(isOpen);
  const { loading_order_ref_no } = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [page_data, setPageData] = useState([]);
  const [sent_data, setSentData] = useState(data);
  const dispatch = useDispatch();
  const [submit_loading, setSubmitLoading] = useState(false);
  const [submit_error, setSubmitError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [loadingOrderProductItems, setLoadingOrderProductItems] = useState([]);
  const [productListLoading, setProductListLoading] = useState(true);
  const [product_data, setProductData] = useState([]);
  const [branches_data, setBranchesData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [warehousestorageslist, setWarehouseStoragesList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [packet_sizes, setPacketSizes] = useState([]);
  const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
  const [error_confirm, setErrorConfirm] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
    if (!isOpen) return; // prevent running when modal is closed


    if (data)
    {
      setLoading(true);

      setFormData(initialState);

      dispatch(
        employee_dashboard_actions_helper(
          loading_retrieve_warehouse_storages_list,
          success_retrieve_warehouse_storages_list,
          fail_retrieve_warehouse_storages_list,
          RETRIEVE_PRODUCTS_LIST_ERR_MSG,
          RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_ACTIVE_AVAILABLE_PRODUCTS_API,
          null,
          RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
        )
      );

      dispatch(
        employee_dashboard_actions_helper(
          loading_product_list,
          success_product_list,
          fail_product_list,
          RETRIEVE_PRODUCTS_LIST_ERR_MSG,
          RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_ACTIVE_PRODUCT_LIST,
          null,
          RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
        )
      );

      dispatch(
        employee_dashboard_actions_helper(
          loading_branch_location_list,
          success_branch_location_list,
          fail_branch_location_list,
          RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG,
          RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_BRANCH_LOCATION_LIST,
          null,
          RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG
        )
      );

      const remapped_products = data?.products?.map((product, index) => ({
        ...initialState,
        id: `${Date.now()}-${index}`,
        product_label: product?.product_name,
        product_id: product?.product_id,
        packet_size: product?.packaging_total_number,
        quantity_in_mt: product?.total_mt_capacity,
        packaging_number: product?.total_capacity_selected_measurement,
        delivery_location: product?.delivery_name,
        product_type_label: product?.product_type_params?.product_type,
        product_type_id: product?.product_type_params?.product_type_id,
        branch_location_label: `${product?.branch_location_params?.branch_area} - ${product?.branch_location_params?.province_name}`,
        branch_location_id: product?.branch_location_params?.branch_location_id,
        warehouse_storage_label: product?.warehouse_storage_type_params?.warehouse_storage_type,
        warehouse_storage_type_id: product?.warehouse_storage_type_params?.warehouse_storage_type_id,
        base_weight_in_kilos: product?.base_weight_in_kilos,
        total_capacity_selected_measurement: product?.base_weight_in_kilos,
      }));


      setLoadingOrderProductItems(remapped_products);

      setSentData(data);
    }
  }, [data, isOpen]);

  const retrieve_warehouse_storages_list = useSelector((state) => state.retrieve_warehouse_storages_list.retrieve_warehouse_storages_list);

  useEffect(() => {
    if (retrieve_warehouse_storages_list.status !== app_consts.IDLE)
    {
      if (retrieve_warehouse_storages_list.status === app_consts.LOADING)
      {
        setProductListLoading(true);
        setError("");
        setLoading(true);
      } else
      {
        setProductListLoading(false);
        setLoading(false);
        if (retrieve_warehouse_storages_list.status === app_consts.FAIL)
        {
          messageToast(retrieve_warehouse_storages_list.message, app_consts.FAIL);
          setError(retrieve_warehouse_storages_list.message);
        } else if (retrieve_warehouse_storages_list.status === app_consts.SUCCESS)
        {
          setBranchesData(retrieve_warehouse_storages_list.data);
          // Set Branch Locations
          const branchLocations = Array.from(
            new Map(retrieve_warehouse_storages_list?.data?.map(d => [d?.branch_location_id, { value: d?.branch_location_id, label: `${d.branch_area} - ${d.province_name}` }])).values()
          );

          setBranches(branchLocations);
        }
        dispatch(reset_retrieve_warehouse_storages_list());
      }
    }
  }, [retrieve_warehouse_storages_list]);


  //Listen to State of Product List
  const product_list = useSelector((state) => state.product_list.product_list);

  useEffect(() => {
    if (product_list.status !== app_consts.IDLE)
    {
      if (product_list.status === app_consts.LOADING)
      {
        setProductListLoading(true);
      } else
      {
        setProductListLoading(false);
        if (product_list.status === app_consts.FAIL)
        {
          messageToast(product_list.message, app_consts.FAIL);
        } else if (product_list.status === app_consts.SUCCESS)
        {
          // Remapp Product Types
          const remapped_product_types = product_list.data?.map((product_type) => { return { label: product_type.product_type, value: product_type.product_type_id }; });
          setProductTypeList(remapped_product_types);
          setProductData(product_list.data);
        }
        dispatch(reset_product_list());
      }
    }
  }, [product_list]);

  const removeOrderItem = (id) => {
    setLoadingOrderProductItems(loadingOrderProductItems.filter(item => item.id !== id));
  };

  // Define one shared style for all RSelects
  const rSelectFixedStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: "180px",   // 👈 fixed width
      width: "180px",      // keep consistent inside table
    }),
    input: (provided) => ({
      ...provided,
      minWidth: "100px",   // prevents shrinking while typing
      width: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      minWidth: "180px",
    }),
  };

  const handleBranchLocationChange = (value, label) => {
    // Filter
    // const filtered_data = branches_data?.filter((data) => value === data?.branch_location_id);

    const filtered_data = branches_data?.filter((data) => value === data?.branch_location_id);

    const storage_types = Array.from(
      new Map(filtered_data?.map(d => [d?.warehouse_storage_type_id, { value: d?.warehouse_storage_type_id, label: d?.warehouse_storage_type }])).values()
    );


    // const storage_types = filtered_data?.map((type) => { return { label: type?.storage_type, value: type?.storage_type_id }; });

    setWarehouseStoragesList(storage_types);

    setFormData({ ...formData, ["branch_location_label"]: label, ["branch_location_id"]: value, ["warehouse_storage_type_id"]: "", ["warehouse_storage_label"]: "", ["quantity_available"]: "", ["packet_size"]: "", product_id: "", product_type_id: "", product_label: "", product_type_label: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
  };

  const handleWarehouseStorageChange = (value, label) => {
    // Filter
    const filtered_data = product_data?.filter((data) => value === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const product_types = Array.from(
    //   new Map(filtered_data?.map(d => [d?.product_type_id, { label: d?.product_type, value: d?.product_type_id }])).values()
    // );

    // setProductTypeList(product_types);

    setFormData({ ...formData, ["warehouse_storage_label"]: label, ["warehouse_storage_type_id"]: value, ["quantity_available"]: "", ["packet_size"]: "", product_id: "", product_type_id: "", product_label: "", product_type_label: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
  };

  const handleProductTypeChange = (value, label) => {

    // const filtered_data = product_data?.filter((data) => value === data?.product_type_id && formData?.warehouse_storage_type_id === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const products = Array.from(
    //   new Map(filtered_data?.map(d => [d?.product_id, { label: d?.product_name, value: d?.product_id }])).values()
    // );


    const filtered_data = product_data?.filter((data) => value === data?.product_type_id);

    const products = Array.from(new Map(filtered_data?.flatMap(d => d?.products || []).filter(p => p?.product_id).map(p => [p?.product_id, { label: p?.product_name, value: p?.product_id }])).values());


    setProductsList(products);

    setFormData({ ...formData, ["product_type_label"]: label, ["product_type_id"]: value, ["quantity_available"]: "", ["packet_size"]: "", product_id: "", product_label: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
  };

  const handleProductChange = (value, label) => {

    // const filtered_data = product_data?.filter((data) => value === data?.product_id && formData?.product_type_id === data?.product_type_id && formData?.warehouse_storage_type_id === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const packet_sizes_list = Array.from(
    //   new Map(filtered_data?.map(d => [d?.product_id, { label: d?.uom_description, value: d?.uom_description }])).values()
    // );

    const filtered_data_1 = product_data?.filter((data) => formData?.product_type_id === data?.product_type_id);
    const filtered_data_2 = filtered_data_1?.filter(d => formData?.product_type_id === d?.product_type_id)?.flatMap(d => d?.products || [])?.filter(p => value === p?.product_id);
    const packet_sizes_list = (filtered_data_2?.[0]?.pum_list || []).flatMap(p => p?.uom_details || []).map(u => ({ label: u.packet_size, value: u.packet_size }));

    setPacketSizes(packet_sizes_list);

    setFormData({ ...formData, ["product_label"]: label, ["product_id"]: value, ["quantity_available"]: "", ["packet_size"]: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });

  };

  const handlePacketSizeChange = (value, label) => {

    // const filtered_data = product_data?.find((data) => value === data?.uom_description && formData?.product_id === data?.product_id && formData?.product_type_id === data?.product_type_id && formData?.warehouse_storage_type_id === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const filtered_data = product_data?.find((data) => value === data?.uom_description && formData?.product_id === data?.product_id && formData?.product_type_id === data?.product_type_id);


    const filtered_data_1 = product_data?.filter((data) => formData?.product_type_id === data?.product_type_id);
    const filtered_data_2 = filtered_data_1?.filter(d => formData?.product_type_id === d?.product_type_id)?.flatMap(d => d?.products || [])?.filter(p => formData?.product_id === p?.product_id);
    const filtered_data_3 = filtered_data_2?.filter(d => d?.pum_list?.some(pl => pl?.uom_details?.some(ud => ud?.packet_size === value)));
    const uom_details_list = filtered_data_3?.flatMap(d => d?.pum_list || []).flatMap(pl => pl?.uom_details?.filter(ud => ud?.packet_size === value) || []);



    setFormData({ ...formData, ["packet_size"]: value, weight_in_kilos: uom_details_list[0]?.measurement_in_kilos, quantity_available: uom_details_list[0]?.available_capacity, packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: uom_details_list[0]?.base_weight_in_kilos });
  };


  const add_products_to_loading_order = () => {
    if (!formData?.branch_location_id || !formData?.warehouse_storage_type_id || !formData?.delivery_location || !formData?.product_id || !formData?.product_type_id || !formData?.base_weight_in_kilos || !formData?.packaging_number || !formData?.quantity_in_mt || !formData?.packet_size) return;

    // Check for Duplicates
    const isDuplicate = loadingOrderProductItems?.find((item) => {
      return item?.branch_location_id === formData.branch_location_id && item?.warehouse_storage_type_id === formData.warehouse_storage_type_id && item?.delivery_location === formData.delivery_location && item?.product_id === formData?.product_id && item?.product_type_id === formData?.product_type_id && item?.packet_size === formData?.packet_size;
    });

    if (isDuplicate)
    {
      messageToast(`Duplicate Entry of ${formData.product_label} at Warehouse ${formData?.branch_location_label}. Storage: ${formData.warehouse_storage_label}`, app_consts.FAIL);
    }
    else
    {
      setLoadingOrderProductItems([...loadingOrderProductItems, { ...formData, branch_location_label: formData?.branch_location_label, branch_location_id: formData?.branch_location_id, warehouse_storage_type_id: formData?.warehouse_storage_type_id, warehouse_storage_label: formData?.warehouse_storage_label, delivery_location: formData?.delivery_location, product_label: formData?.product_label, product_id: formData?.product_id, product_type_label: formData?.product_type_label, product_type_id: formData?.product_type_id, weight_in_kilos: formData?.weight_in_kilos, quantity_available: formData?.quantity_available, packaging_number: formData?.packaging_number, packet_size: formData?.packet_size, quantity_in_mt: formData?.quantity_in_mt, base_weight_in_kilos: formData?.base_weight_in_kilos, id: Date.now() }]);

      setFormData(initialState);
      setWarehouseStoragesList([]);
      // setProductTypeList([]);
      setProductsList([]);
      setPacketSizes([]);
    }
  };

  const handleSubmit = () => {
    setErrorConfirm("");
    const api_data = { products: loadingOrderProductItems, loading_order_ref_no: loading_order_ref_no };
    dispatch(
      employee_dashboard_actions_helper(
        loading_add_product_to_loading_order,
        success_add_product_to_loading_order,
        fail_add_product_to_loading_order,
        EDIT_LOADING_ORDER_PRODUCTS_ERR_MSG,
        EDIT_LOADING_ORDER_PRODUCTS_SUCCESS_MSG,
        app_consts.POST,
        EDIT_LOADING_ORDER_PRODUCTS_API,
        api_data,
        EDIT_LOADING_ORDER_PRODUCTS_ACCESS_DENIED_MSG
      )
    );
  };


  // Listen to the Changes
  const product_add_listener = useSelector((state) => state.add_product_to_loading_order.add_product_to_loading_order);

  useEffect(() => {
    if (product_add_listener.status !== app_consts.IDLE)
    {
      if (product_add_listener.status === app_consts.LOADING)
      {
        setErrorConfirm("");
      } else
      {
        if (product_add_listener.status === app_consts.FAIL)
        {
          messageToast(product_add_listener.message, app_consts.FAIL);
          setErrorConfirm(product_add_listener.message);
        } else if (product_add_listener.status === app_consts.SUCCESS)
        {
          messageToast(EDIT_LOADING_ORDER_PRODUCTS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          cloasModal();
        }
        dispatch(reset_add_product_to_loading_order());
      }
    }
  }, [product_add_listener]);

  return (
    <>
      <Modal
        isOpen={open}
        className="modal-dialog-centered"
        size={"xl"}
        fullscreen
      >
        <ModalHeader toggle={(!loading || !submit_loading) ? cloasModal : undefined}>Edit Loading Order Products {sent_data?.loading_order_ref_no ? `: ${sent_data?.loading_order_ref_no}` : ""}</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <AuthLoader loading_message="Retrieving Loading Order Details..." />
              </>
              :
              <>
                {
                  error && error.length > 0 ?
                    <>
                      <AuthError error_message={error} />
                    </>
                    :
                    <>
                      <div className="card-inner bg-white">
                        <Block>
                          <BlockHead>
                            <BlockTitle tag="h5">Products</BlockTitle>
                          </BlockHead>
                          {submit_error && (
                            <div className="mb-3 w-100">
                              <Alert color="danger" className="alert-icon">
                                <Icon name="alert-circle" /> {submit_error}{" "}
                              </Alert>
                            </div>
                          )}
                          <BlockBetween>
                            {
                              sent_data?.loading_order_status?.toLowerCase() === app_consts.PENDING_DN_PROCESSING?.toLowerCase() && loadingOrderProductItems?.length > 0 && (
                                <>
                                  <Button color="primary"
                                    size="sm" onClick={() => setOpenConfirmCancelModal(!openConfirmCancelModal)}>Edit Products</Button>
                                </>
                              )
                            }
                          </BlockBetween>
                          <div className="nk-tb-list is-separate is-medium mb-3">
                            <DataTableHead className="nk-tb-item">
                              <DataTableRow size="lg"><span className="sub-text">Branch Location</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Storage Type</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Delivery Location</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Product Type</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Weight(KGs)</span></DataTableRow>
                              {/* <DataTableRow size="lg"><span className="sub-text">Quantity Available (MT)</span></DataTableRow> */}
                              <DataTableRow size="lg"><span className="sub-text">Packaging Number</span></DataTableRow>
                              <DataTableRow size="lg"><span className="sub-text">Quantity (MT)</span></DataTableRow>
                            </DataTableHead>
                            {loadingOrderProductItems.length > 0 &&
                              loadingOrderProductItems.map((item) => (
                                <DataTableItem key={item.id}>
                                  <DataTableRow><span className="tb-sub">{item?.branch_location_label || "--"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.warehouse_storage_label || "--"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.delivery_location || "--"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.product_type_label || "--"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.product_label || "--"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.packet_size || "--"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.base_weight_in_kilos || "0"}</span></DataTableRow>
                                  {/* <DataTableRow><span className="tb-sub">{item?.quantity_available || "0"}</span></DataTableRow> */}
                                  <DataTableRow><span className="tb-sub">{item?.packaging_number || "0"}</span></DataTableRow>
                                  <DataTableRow><span className="tb-sub">{item?.quantity_in_mt || "0"}</span></DataTableRow>
                                  <DataTableRow className="nk-tb-col-tools">
                                    <Button color="danger" size="sm" onClick={() => removeOrderItem(item.id)}>Remove</Button>
                                  </DataTableRow>
                                </DataTableItem>
                              ))}

                            {/* Add New Order Item */}
                            <DataTableItem>
                              {/* Branch Location */}
                              <DataTableRow>
                                <RSelect
                                  options={branches}
                                  className="w-100"
                                  placeholder="Search"
                                  id="branch_location_id"
                                  isLoading={productListLoading}
                                  onChange={(e) => { handleBranchLocationChange(e.value, e.label); }}
                                  value={getSelectedOption(formData?.branch_location_id, branches)}
                                  styles={rSelectFixedStyles}   // 👈 use shared styles
                                />
                              </DataTableRow>

                              {/* Warehouse Storage */}
                              <DataTableRow>
                                <RSelect
                                  options={warehousestorageslist}
                                  className="w-100"
                                  placeholder="Search"
                                  id="warehouse_storage_type_id"
                                  onChange={(e) => { handleWarehouseStorageChange(e.value, e.label); }}
                                  isDisabled={!formData?.branch_location_id}
                                  value={getSelectedOption(formData?.warehouse_storage_type_id, warehousestorageslist)}
                                  styles={rSelectFixedStyles}
                                />
                              </DataTableRow>

                              {/* Delivery Location */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <TextInput
                                    required
                                    type="text"
                                    value={formData.delivery_location}
                                    colSize="10"
                                    disabled={!formData?.warehouse_storage_type_id}
                                    handleChange={(e) => setFormData({ ...formData, delivery_location: e.target.value })}
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Product Type */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <RSelect
                                    options={productTypeList}
                                    className="w-100"
                                    placeholder="Search"
                                    id="product_type"
                                    onChange={(e) => { handleProductTypeChange(e.value, e.label); }}
                                    isDisabled={!formData?.delivery_location}
                                    value={getSelectedOption(formData.product_type_id, productTypeList)}
                                    styles={rSelectFixedStyles}
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Product */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <RSelect
                                    options={productsList}
                                    className="w-100"
                                    placeholder="Search"
                                    id="product_id"
                                    onChange={(e) => { handleProductChange(e.value, e.label); }}
                                    isDisabled={!formData.product_type_id}
                                    value={getSelectedOption(formData.product_id, productsList)}
                                    styles={rSelectFixedStyles}
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Packet Size */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <RSelect
                                    options={packet_sizes}
                                    className="w-100"
                                    placeholder="Search"
                                    id="packet_size"
                                    onChange={(e) => { handlePacketSizeChange(e.value, e.label); }}
                                    isDisabled={!formData.product_id}
                                    value={getSelectedOption(formData.packet_size, packet_sizes)}
                                    styles={rSelectFixedStyles}
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Base Weight */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <TextInput
                                    required
                                    type="number"
                                    value={formData.base_weight_in_kilos}
                                    colSize="10"
                                    disabled
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Packaging Number */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <TextInput
                                    required
                                    type="number"
                                    value={formData?.packaging_number}
                                    colSize="10"
                                    disabled={!formData?.packet_size}
                                    handleChange={(e) => {
                                      const selected = parseFloat(e.target.value) || 0;
                                      const density = parseFloat(formData.base_weight_in_kilos) || 0;

                                      const totalMT = density ? (selected * density) / 1000 : 0;

                                      setFormData({
                                        ...formData,
                                        packaging_number: selected,
                                        quantity_in_mt: totalMT,
                                      });
                                    }}
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Quantity in MT */}
                              <DataTableRow>
                                <Row className="g-4">
                                  <TextInput
                                    required
                                    type="number"
                                    value={formData?.quantity_in_mt}
                                    colSize="10"
                                    disabled={!formData?.packet_size}
                                    handleChange={(e) => {
                                      const totalMT = parseFloat(e.target.value) || 0;
                                      const base = parseFloat(formData.base_weight_in_kilos) || 0;

                                      const selectedMeasurement = base ? (totalMT * 1000) / base : 0;

                                      setFormData({
                                        ...formData,
                                        quantity_in_mt: totalMT,
                                        packaging_number: parseFloat(selectedMeasurement)?.toFixed(2),
                                      });
                                    }}
                                  />
                                </Row>
                              </DataTableRow>

                              {/* Add Button */}
                              <DataTableRow>
                                <Button
                                  color="primary"
                                  disabled={loading || !(formData?.branch_location_id &&
                                    formData?.product_id &&
                                    formData?.warehouse_storage_type_id &&
                                    formData?.packaging_number &&
                                    formData?.packet_size &&
                                    formData?.product_type_id &&
                                    formData?.quantity_in_mt > 0 &&
                                    formData?.delivery_location &&
                                    formData?.weight_in_kilos &&
                                    formData?.base_weight_in_kilos &&
                                    formData?.packaging_number &&
                                    formData?.quantity_in_mt)}
                                  size="sm"
                                  onClick={add_products_to_loading_order}
                                >
                                  Add
                                </Button>
                              </DataTableRow>
                            </DataTableItem>
                          </div>
                        </Block>
                      </div>
                    </>
                }

                {/* Yes or No Modal */}
                <ModalConfirmCancel
                  openModal={openConfirmCancelModal}
                  setOpenModal={setOpenConfirmCancelModal}
                  modalTitle={`Edit Products on Loading Order ${sent_data?.loading_order_ref_no}`}
                  modalDescription={`Are you sure that you want to Edit Products on Loading Order ${sent_data?.loading_order_ref_no}?`}
                  buttonConfirm="Confirm"
                  buttonCancel="Cancel"
                  succFunc={handleSubmit}
                  errAmend={error_confirm}
                  setErrAmend={setErrorConfirm}
                />
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default EditLoadingOrderProductsModal;